import { useTranslation } from 'react-i18next';

import { BannerHelper } from '@/components/common/BannerToast';
import InformationModal from '@/components/dashboard/knowledge-bases-create/InformationModal';
import { WrappedErrorBoundary } from '@/pages/WrappedErrorBoundary';

function Banner() {
  const { t } = useTranslation();

  return (
    <BannerHelper
      message={t('HelpBanner/ChatbotCreation/hint')}
      buttons={
        <InformationModal
          btnTitle={t('HelpBanner/ChatbotCreation/cta')}
          modalTitle={t('HelpBanner/ChatbotCreation/cta')}
          content={[
            t('HelpBanner/ChatbotCreation/content1'),
            t('HelpBanner/ChatbotCreation/content2'),
            t('HelpBanner/ChatbotCreation/content3'),
            t('HelpBanner/ChatbotCreation/content4'),
          ]}
          youtube={{
            enUrl: 'https://www.youtube.com/embed/euxVR-EqKQ4',
            frUrl: 'https://www.youtube.com/embed/euxVR-EqKQ4',
          }}
        />
      }
    />
  );
}

export default WrappedErrorBoundary(Banner);
